<template>
	<div class="color-picker">
		<btn s="xs" @press="openModal">
			<span :style="{backgroundColor:color}" class="color-template"></span>
		</btn>
		<pin-modal  ref="modal" label='Выбор цвета'>
			<sketch-picker :value="color" @input="updateValue"/>
		</pin-modal>
	</div>
</template>
<script>
	import PinModal from "./pin-modal.vue";
	var defaultProps = {
	  hex: '#194d33',
	  hsl: {
	    h: 150,
	    s: 0.5,
	    l: 0.2,
	    a: 1
	  },
	  hsv: {
	    h: 150,
	    s: 0.66,
	    v: 0.30,
	    a: 1
	  },
	  rgba: {
	    r: 25,
	    g: 77,
	    b: 51,
	    a: 1
	  },
	  a: 1
	};
	import { Sketch } from 'vue-color'
	export default {
		name:"color-picker",
		props:{
			color:{
				type:String,
				default:'red'
			}
		},
		components:{PinModal,'sketch-picker':Sketch},
		methods:{
			updateValue(v){
				this.$emit('input',v.hex);
			},
			openModal(e){
				this.$refs.modal.onOpen(e);
			}
		},
		data(){
			return {
				colors: defaultProps
			}
		}
	}
</script>
<style scoped>
	.color-picker{
		display: inline-block;
		vertical-align: middle;
	}
	.color-template{
		width:24px;
		height:14px;
		margin:2px;
		display: inline-block;
	}

	.vc-sketch{
		border-radius: 0;
		box-shadow:none;
	}
</style>